import type { HRDocument } from "./api";

export type DocumentRequestType = "upload" | "signature" | "upload_and_sign";
export function documentRequestType(document: Pick<HRDocument, "requestType">): DocumentRequestType {
  return document.requestType ?? "upload_and_sign";
}
export function documentNeedsSignature(document: Pick<HRDocument, "requestType">): boolean {
  return documentRequestType(document) !== "upload";
}
